import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header card-header-jaya border-primary" }
const _hoisted_3 = { class: "card-body border-top p-5 p-md-9 d-flex justify-content-center align-items-center flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center mb-3 px-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Cette section évalue l’impact des pratiques agricoles sur une sélection de services écosystémiques "),
  /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, " (bénéfices que les humains retirent des écosystèmes). "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Ils estiment le potentiel de contribution basé sur les données renseignées dans votre diagnostic. ")
], -1)
const _hoisted_5 = { class: "col-12 d-flex flex-column" }
const _hoisted_6 = { class: "col-12 d-flex justify-content-between order-xl-1" }
const _hoisted_7 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_9 = {
  key: 0,
  class: "notice bg-light-warning rounded border-warning border border-dashed p-5 m-5 text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning fs-6 fw-bolder" }, "Attention ! Vous n'avez qu'un seul diagnostic sur cette exploitation.", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col-12 d-flex flex-column align-items-center order-xl-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "w-80"
}
const _hoisted_15 = {
  key: 2,
  style: {"height":"350px","width":"350px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic text-dark" }, " Cliquez sur les données du graphique pour obtenir plus d'informations ", -1)
const _hoisted_17 = { class: "col-12 d-flex flex-column align-items-center" }
const _hoisted_18 = { class: "text-black" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle fs-2 text-secondary" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "mt-7 d-flex flex-column align-items-center"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-5 fw-bold\">État de la contribution :</div><div class=\"d-flex flex-wrap justify-content-center align-items-center\"><div class=\"text-danger fs-5 fw-boldest px-4 text-center\"> Faible <div class=\"fw-normal fst-italic\">(0 - 33%)</div></div><div class=\"text-warning fs-5 fw-boldest px-4 text-center\"> Moyen <div class=\"fw-normal fst-italic\">(34 - 66%)</div></div><div class=\"text-primary fs-5 fw-boldest px-4 text-center\"> Fort <div class=\"fw-normal fst-italic\">(67 - 100%)</div></div></div>", 2)
const _hoisted_25 = [
  _hoisted_23
]
const _hoisted_26 = { class: "mt-7 d-flex flex-column align-items-center w-100" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Comparaisons", -1)
const _hoisted_28 = { class: "row w-100 justify-content-center align-items-center" }
const _hoisted_29 = { class: "col-6 col-lg-3 p-2" }
const _hoisted_30 = { class: "d-flex justify-content-center" }
const _hoisted_31 = { class: "svg-icon svg-icon-3x svg-icon-primary" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-center fs-3 mb-0" }, "Avec des moyennes", -1)
const _hoisted_33 = { class: "col-6 col-lg-3 p-2" }
const _hoisted_34 = { class: "d-flex justify-content-center" }
const _hoisted_35 = { class: "svg-icon svg-icon-3x svg-icon-secondary" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-center fs-3 mb-0" }, "Évolution temporelle", -1)
const _hoisted_37 = {
  key: 0,
  class: "col-12 p-2 d-flex justify-content-center"
}
const _hoisted_38 = {
  id: "chooseOTEX",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title d-flex align-items-center" }, " Choisir une autre source de données "),
  /*#__PURE__*/_createElementVNode("div", {
    "aria-label": "Close",
    class: "btn btn-icon btn-sm btn-danger ms-2",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-1" })
  ])
], -1)
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "Tout OTEX confondu", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Sans OTEX", -1)
const _hoisted_45 = ["value"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "Tout SIQO confondu", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Sans SIQO", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "France entière", -1)
const _hoisted_50 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_title_jaya, {
        "duotune-icon": "technology/teh010",
        title: 
          'Mes contributions aux services  \'' +
          _ctx.ecosystemicServicesCategory.name +
          '\''
        ,
        subTitle: _ctx.diagnosticName
      }, null, 8, ["title", "subTitle"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.classRadial, "btn btn-white btn-active-light-primary btn-active-icon-primary btn-active-text-primary w-50 rounded-0"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setType('radialBar')))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, {
                src: 
                  require('@/../public/media/icons/duotune/graphs/gra008.svg')
                
              }, null, 8, ["src"])
            ]),
            _createTextVNode("Radial")
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.chartType === 'bar' ? `btn-light-primary` : ``, "btn btn-white btn-active-light-primary btn-active-icon-primary btn-active-text-primary w-50 rounded-0"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setType('bar')))
          }, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, {
                src: 
                  require('@/../public/media/icons/duotune/graphs/gra004.svg')
                
              }, null, 8, ["src"])
            ]),
            _createTextVNode("Bâtons")
          ], 2)
        ]),
        (_ctx.seriesBar.length === 1 && _ctx.displayTime === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.chartType === 'radialBar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.chartType === 'radialBar')
                  ? (_openBlock(), _createBlock(_component_apexchart, {
                      key: 0,
                      options: _ctx.chartOptions,
                      series: _ctx.series,
                      type: "radialBar",
                      onDataPointSelection: _ctx.onDataPointSelection,
                      class: "apexchart-es",
                      id: "chartRadial",
                      width: "350",
                      height: "350"
                    }, null, 8, ["options", "series", "onDataPointSelection"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.chartType === 'bar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.chartType === 'bar')
                  ? (_openBlock(), _createBlock(_component_apexchart, {
                      key: 0,
                      options: _ctx.chartOptionsBar,
                      series: _ctx.seriesBar,
                      type: "bar",
                      onDataPointSelection: _ctx.onDataPointSelection,
                      id: "chartBar",
                      height: "350",
                      width: "350"
                    }, null, 8, ["options", "series", "onDataPointSelection"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.chartType === 'None')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15))
            : _createCommentVNode("", true),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Datatable, {
          "enable-items-per-page-dropdown": _ctx.legendData.length > 20,
          "table-data": _ctx.legendData,
          "table-header": _ctx.tableHeader,
          rowsPerPage: 15,
          class: "service-legend"
        }, {
          "cell-service": _withCtx(({ row: service }) => [
            _createElementVNode("div", _hoisted_18, _toDisplayString(service.short_name), 1)
          ]),
          "cell-description": _withCtx(({ row: service }) => [
            _createElementVNode("div", null, _toDisplayString(service.name), 1)
          ]),
          "cell-info": _withCtx(({ row: service }) => [
            _createElementVNode("a", {
              class: "cursor-pointer text-gray",
              onClick: ($event: any) => (_ctx.displayServiceDetail(service))
            }, _hoisted_21, 8, _hoisted_19)
          ]),
          _: 1
        }, 8, ["enable-items-per-page-dropdown", "table-data", "table-header"]),
        (!_ctx.displayMeans && !_ctx.displayTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", {
                class: _normalizeClass(["btn btn-active-primary p-3 rounded-2 cursor-pointer text-center w-100 h-100", 
                  _ctx.displayMeans
                    ? 'btn-primary'
                    : 'btn-outline btn-outline-primary bg-white'
                ]),
                "data-bs-target": "#chooseOTEX",
                "data-bs-toggle": "modal"
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_inline_svg, {
                      src: 
                        require('@/../public/media/icons/duotune/graphs/gra009.svg')
                      
                    }, null, 8, ["src"])
                  ])
                ]),
                _hoisted_32
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("a", {
                class: _normalizeClass(["btn btn-active-secondary p-3 rounded-2 cursor-pointer text-center w-100 h-100", 
                  _ctx.displayTime
                    ? 'btn-secondary'
                    : 'btn-outline btn-outline-secondary bg-white'
                ]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fetchTime && _ctx.fetchTime(...args)))
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, [
                    _createVNode(_component_inline_svg, {
                      src: 
                        require('@/../public/media/icons/duotune/graphs/gra012.svg')
                      
                    }, null, 8, ["src"])
                  ])
                ]),
                _hoisted_36
              ], 2)
            ]),
            (_ctx.displayTime || _ctx.displayMeans)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetCharts && _ctx.resetCharts(...args)))
                  }, "Réinitialiser")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingOTEX.id) = $event)),
              "aria-label": "Selection OTEX",
              class: "form-select form-control form-control-lg form-control-solid mb-1"
            }, [
              _hoisted_43,
              _hoisted_44,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOTEX.sort((a, b) => (a.id < b.id ? -1 : 1)), (otex) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: otex.id,
                  value: otex.id
                }, " OTEX : " + _toDisplayString(otex.name), 9, _hoisted_45))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.editingOTEX.id]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingSIQO.id) = $event)),
              "aria-label": "Selection SIQO",
              class: "form-select form-control form-control-lg form-control-solid mt-1"
            }, [
              _hoisted_46,
              _hoisted_47,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSIQO.sort((a, b) =>
                  a.name < b.name ? -1 : 1
                ), (siqo) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: siqo.id,
                  value: siqo.id
                }, _toDisplayString(siqo.name), 9, _hoisted_48))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.editingSIQO.id]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingDepartment.id) = $event)),
              "aria-label": "Selection SIQO",
              class: "form-select form-control form-control-lg form-control-solid mt-1"
            }, [
              _hoisted_49,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (department) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: department.id,
                  value: department.id
                }, _toDisplayString(department.insee_dep) + " - " + _toDisplayString(department.name), 9, _hoisted_50))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.editingDepartment.id]
            ]),
            _createElementVNode("a", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fetchMeans && _ctx.fetchMeans(...args))),
              class: "btn btn-primary float-end mt-3",
              "data-bs-dismiss": "modal"
            }, " Valider ")
          ])
        ])
      ])
    ])
  ]))
}